import { CommonModule } from '@angular/common';
import { Component, Input, Output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../../material.module';
import { Routes } from "@angular/router";
import { EventEmitter } from '@angular/core';
import { NotesofaccountsComponent } from '../notesofaccounts.component';

@Component({
  selector: 'app-note7',
  imports: [TablerIconsModule, MaterialModule, CommonModule, RouterModule, MatTabsModule, NotesofaccountsComponent],
  templateUrl: './note7.component.html',
  styleUrl: './note7.component.scss'
})
export class Note7Component {

  constructor(private router: Router, private ParentCoponent: NotesofaccountsComponent) {
    alert('child')
  }
  ngOnInit(): void {
    alert('ngonit')
    this.SaveandNextNote(this.selectedNoteFromParent, false)
  }
  selectNotes: boolean = true; selectedNotes: boolean = false;

  CurrentNote: string;
  CurrentNoteisactive: string;

  note24: boolean = false; isActive24: boolean = false; note25: boolean = false; isActive25: boolean = false; note26: boolean = false; isActive26: boolean = false;
  note27: boolean = false; isActive27: boolean = false; note28: boolean = false; isActive28: boolean = false; note29: boolean = false; isActive29: boolean = false;
  note30: boolean = false; isActive30: boolean = false; note31: boolean = false; isActive31: boolean = false; note32: boolean = false; isActive32: boolean = false;
  note33: boolean = false; isActive33: boolean = false; note34: boolean = false; isActive34: boolean = false; note35: boolean = false; isActive35: boolean = false;

  @Output() childClicked = new EventEmitter<string>(); // Emits a string
  @Input() selectedNoteFromParent: string; // This receives data from the parent
  emitClickEvent(CurrentNote: any) {
    this.childClicked.emit(CurrentNote);
  }

  displayedColumns: string[] = ['id', 'Description', 'thisyear', 'lastyear', 'action'];
  data: any[] = [
    { type: 'Extraordinary item 1', Description: '', Year: '' },
  ];

  displayedMainColumnsNote8: string[] = ['particulars', 'Amount received', 'Amount paid out', 'Balance held at period end', 'actionmain'];
  displayedColumnsNote8: string[] = ['Description/name of party', 'Related party (Yes or No)', 'thisYear', 'lastYear', 'thisYear2', 'lastYear2', 'thisYear3', 'lastYear3', 'action',];
  dataNote8: any[] = [
    { type: 'Incurred seeking donations', Description: '', Year: '' },
    { type: 'Incurred seeking legacies', Description: '', Year: '' },
    { type: 'Incurred seeking grants', Description: '', Year: '' },
  ];

  displayedMainColumnsConsortiaNote8: string[] = ['particulars', 'Balance held at period end', 'actionmain'];
  displayedColumnsConsortiaNote8: string[] = ['Description/name of party', 'thisYear', 'lastYear', 'action',];
  dataConsortiaNote8: any[] = [
    { type: 'Incurred seeking donations', Description: '', Year: '' },
    { type: 'Incurred seeking legacies', Description: '', Year: '' },
  ];

  displayedColumnsNote9: string[] = ['Support cost (examples)', 'Raising funds', 'Activity 1', 'Activity 2', 'Activity 3', 'Grand total', 'Basis of allocation',];
  secondaryFooterDisplayedColumns: string[] = ['GovernanceSupport cost (examples)', 'GovernanceRaising funds', 'GovernanceActivity 1', 'GovernanceActivity 2', 'GovernanceActivity 3', 'GovernanceGrand total', 'GovernanceBasis of allocation',];
  thirdFooterDisplayedColumns: string[] = ['OtherSupport cost (examples)', 'OtherRaising funds', 'OtherActivity 1', 'OtherActivity 2', 'OtherActivity 3', 'OtherGrand total', 'OtherBasis of allocation',];
  dataNote9: any[] = [
    { type: 'Incurred seeking donations', Description: '', Year: '' },
    { type: 'Incurred seeking legacies', Description: '', Year: '' },
  ];

  displayedColumnslastYearNote9: string[] = ['Support cost (examples)', 'Raising funds', 'Activity 1', 'Activity 2', 'Activity 3', 'Grand total', 'Basis of allocation',];
  secondaryFooterDisplayedColumnslastYear: string[] = ['GovernanceSupport cost (examples)', 'GovernanceRaising funds', 'GovernanceActivity 1', 'GovernanceActivity 2', 'GovernanceActivity 3', 'GovernanceGrand total', 'GovernanceBasis of allocation',];
  thirdFooterDisplayedColumnslastYear: string[] = ['OtherSupport cost (examples)', 'OtherRaising funds', 'OtherActivity 1', 'OtherActivity 2', 'OtherActivity 3', 'OtherGrand total', 'OtherBasis of allocation',];
  datalastYearNote9: any[] = [
    { type: 'Incurred seeking donations', Description: '', Year: '' },
    { type: 'Incurred seeking legacies', Description: '', Year: '' },
  ];

  displayedColumnsNote10: string[] = ['id', 'thisyear', 'lastyear', 'action'];
  dataNote10: any[] = [
    { type: 'Government grant 1', Description: '', Year: '' },
  ];

  displayedColumnsNote11: string[] = ['id', 'thisyear', 'lastyear',];
  dataNote11: any[] = [
    { type: 'Salaries and wages', Description: '', Year: '' },
    { type: 'Social security costs', Description: '', Year: '' },
    { type: 'Pension costs (defined contribution scheme)', Description: '', Year: '' },
    { type: 'Other employee benefits', Description: '', Year: '' },
  ];

  displayedMainColumnsBandNote11: string[] = ['Band', 'Number of employees'];
  displayedColumnsBandNote11: string[] = ['id', 'thisyear', 'lastyear',];
  dataBandNote11: any[] = [
    { type: '£60,000 to £69,999', Description: '', Year: '' },
    { type: '£70,000 to £79,999', Description: '', Year: '' },
    { type: '£80,000 to £89,999', Description: '', Year: '' },
    { type: '£90,000 to £99,999', Description: '', Year: '' },
    { type: '£100,000 to £109,999', Description: '', Year: '' },
  ];

  displayedMainColumnsemployeesNote11: string[] = ['The parts of the charity in which the employees work'];
  displayedColumnsemployeesNote11: string[] = ['Area', 'thisyear', 'lastyear',];
  dataemployeesNote11: any[] = [
    { type: 'Fundraising', Description: '', Year: '' },
    { type: 'Charitable activities', Description: '', Year: '' },
    { type: 'Governance', Description: '', Year: '' },
    { type: 'Other', Description: '', Year: '' },
  ];

  BackNote() {
    debugger
    var currentNoteNumber
    var currentNoteisactive = null
    var NextNoteisactive = null
    var NextNoteNumvber = ''
    currentNoteNumber = this.CurrentNote.split('note')[1]
    currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]

    NextNoteisactive = `isActive${+currentNoteisactive - 1}`
    NextNoteNumvber = `note${+currentNoteNumber - 1}`
    this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    this.ParentCoponent.ChangeIsActiveFromChild(NextNoteisactive)
  }
  SaveandNextNote(note?: any, IsNextClick?: any) {
    debugger

    var currentNoteNumber
    var currentNoteisactive = null
    var NextNoteisactive = null
    var NextNoteNumvber = ''
    if (IsNextClick == false) {
      var Parentnote = this.selectedNoteFromParent.split('/')
      currentNoteNumber = Parentnote[0].split('note')[1]
      currentNoteisactive = Parentnote[1].split('isActive')[1]
      NextNoteNumvber = `note${+currentNoteNumber}`

      this.CurrentNote = NextNoteNumvber
      NextNoteisactive = `isActive${+currentNoteisactive}`
    }
    else {

      currentNoteNumber = this.CurrentNote ? this.CurrentNote.split('note')[1] : note.split('note')[1]
      currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]

      NextNoteisactive = `isActive${+currentNoteisactive + 1}`
      NextNoteNumvber = `note${+currentNoteNumber + 1}`
    }
    this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    this.ParentCoponent.ChangeIsActiveFromChild(NextNoteisactive)

  }

  ClickSelectedNote(note: string, IsActive?: any): void {
    debugger
    this.note24 = false;
    this.isActive24 = false;
    (this as any)[note] = true;

    // this.emitClickEvent(this.CurrentNote)
    this.CurrentNoteisactive = IsActive
    this.CurrentNote = note


  }

  SaveAndNext() {
    debugger
    var currentNoteNumber = this.CurrentNote.split('note')[1]
    // var currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]
    var NextNoteNumvber = `note${+currentNoteNumber + 1}`
    // var NextNoteisactive = `isActive${+currentNoteisactive + 1}`
    //   this.ClickSelectedNote(NextNoteNumvber, NextNoteisactive)
    // this.router.navigate([''])
  }
}
